import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from "@angular/core";
import { IPlanningSessionConflict } from "@webapp/sessions/models/sessions.model";
import {
  ConfirmDeleteWithInputComponent,
  ConfirmDeleteWithInputModalData,
} from "@webapp/shared/modal/components/confirm-delete-with-input/confirm-delete-with-input.component";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";

export interface ConfirmDeleteSessionModalData extends ConfirmDeleteWithInputModalData {
  conflicts: IPlanningSessionConflict[];
  sessionId: string;
}

@Component({
  selector: "confirm-delete-session",
  templateUrl: "confirm-delete-session.component.html",
  styleUrls: ["confirm-delete-session.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDeleteSessionComponent {
  public conflicts: IPlanningSessionConflict[];
  public sessionId: string;
  public hasConflicts: boolean;
  private confirmDeleteWithInputComponent: ConfirmDeleteWithInputComponent;

  @ViewChild(ConfirmDeleteWithInputComponent, { static: false })
  public set confirmDeleteWithInput(component: ConfirmDeleteWithInputComponent) {
    if (component) {
      this.confirmDeleteWithInputComponent = component;
    }
  }

  constructor(private cdr: ChangeDetectorRef, @Inject(UI_MODAL_DATA) modalData: ConfirmDeleteSessionModalData) {
    this.conflicts = modalData.conflicts;
    this.sessionId = modalData.sessionId;
    this.hasConflicts = this.conflicts.length > 0;
  }

  public get canDelete(): boolean {
    return !this.hasConflicts && this.confirmDeleteWithInputComponent.canDelete;
  }

  public setDeletingProgress(): void {
    this.confirmDeleteWithInputComponent.setDeletingProgress();
  }

  public setDeletingError(error: string): void {
    this.confirmDeleteWithInputComponent.setDeletingError(error);
  }

  public ignoreConflicts(): void {
    this.hasConflicts = false;
    this.cdr.markForCheck();
  }
}
